/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraResourceTrendResourceChangeStatusQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("InfraResourceTrendResourceChangeStatusQueryOperator");
    }

    getFixupPrototypeFunction() { return InfraResourceTrendResourceChangeStatusQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<InfraResourceTrendResourceChangeStatusQueryOperator>): InfraResourceTrendResourceChangeStatusQueryOperator {
        let obj = Object.assign(new InfraResourceTrendResourceChangeStatusQueryOperator(), model);
        InfraResourceTrendResourceChangeStatusQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraResourceTrendResourceChangeStatusQueryOperator>): InfraResourceTrendResourceChangeStatusQueryOperator {
        if (!model) return null;
        return InfraResourceTrendResourceChangeStatusQueryOperator.newInstance(<InfraResourceTrendResourceChangeStatusQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraResourceTrendResourceChangeStatusQueryOperator) {
        if (!obj) return;

        models.InfraResourceTrendResourceChangeStatusQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraResourceTrendResourceChangeStatusQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfraResourceTrendResourceChangeStatusQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Resource Change Statuses to include
     */
    change_statuses: Array<models.InfraResourceChangeStatus>;

}
